import React from 'react'
import Link from 'gatsby-link'

import me3 from '../layouts/images/me3.jpg'

const ContactPage = () => (

    <div className="container">
        <div className="row">

            <div className="col-lg-5 col-md-4 col-sm-6">
                <img className="profile-pic" src={me3} />
                <br />
            </div>

            <div className="col-lg-7 col-md-8 col-sm-5 about">

                <br />
                <br />
                <br />
                <div className="contact-box">
                    <br />
                    <br />
                    <br />
                    <br />
                    <a href="mailto:sandra.harrison@boostedhuman.com"><span className="inline-header">Contact Me:</span><br />sandra.harrison@boostedhuman.com</a>
                    <br />
                    <br />
                    <a href="https://twitter.com/SanniHarrison" className="twitter-follow-button" data-show-count="false">Follow</a>
                    <br />
                    <br />
                    <script src="//platform.linkedin.com/in.js" type="text/javascript"></script>
                    <script type="IN/MemberProfile" data-id="https://www.linkedin.com/pub/sandra-harrison/97/589/362" data-format="click" data-text="Sandra Harrison"></script>
                </div>
            </div>
        </div>
    </div>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js